/**
 * Generator → VaultNewPage 用の transient in-memory handoff store。
 *
 * `#tools/generator` の「新規アイテムに使用」button から `#vault/new` へ
 * 遷移する際、生成した password を URL hash に乗せると:
 *   - browser history / 拡張に漏洩する
 *   - hash query (`?pw=...`) は HashRouter のルート照合 (`route === 'vault/new'`)
 *     を破壊し、`VaultDetailPage(id="new?pw=...")` にフォールバックして 404 を引く
 *
 * を解決するため、module-level の一回限り取り出し store を使う。
 *
 *   - `setPendingPassword(pw)` で書き込み (Generator side)
 *   - `consumePendingPassword()` で取り出し (VaultNewPage 初回 mount)
 *   - 取り出し後は自動 zeroize (string なので原理的に GC 待ちだが、参照は即解放)
 *
 * 別 tab / 別 ProgressEntry には引き継がない (Vite HMR で module reset されると消える)。
 * これは仕様 — 1 タブ内の即時 handoff のみ想定。
 */

let pendingPassword: string | null = null

export const setPendingPassword = (pw: string): void => {
  pendingPassword = pw
}

export const consumePendingPassword = (): string | null => {
  const out = pendingPassword

  pendingPassword = null

  return out
}

/** Test 用 — 手動 clear 経路 */
export const __resetPendingPasswordForTest = (): void => {
  pendingPassword = null
}
